import { useEffect } from "react";

type FakeProcessingProps = {
  onDone: () => void;
};

export function FakeProcessing({ onDone }: FakeProcessingProps) {
  useEffect(() => {
    const t = setTimeout(onDone, 1800);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div className="space-y-4 rounded-3xl border border-[var(--line)] bg-white py-20 text-center shadow-sm">
      <div className="mx-auto h-11 w-11 animate-spin rounded-full border-2 border-[var(--brand)] border-t-transparent" />
      <p className="text-sm font-medium text-[var(--text-muted)]">
        Calculating your estimate...
      </p>
    </div>
  );
}
